module.exports = __webpack_public_path__ + "static/media/Oaks-of-Northville-By-Laws.34fcc8ef.pdf";